/**
 * Created by codingnuts on 2017/12/9.
 */
const readProd = true;

export default readProd;


// WEBPACK FOOTER //
// ./src/projects/shijiku/config/index.js